import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { auth } from '../config/Firebase';
import { signOut, onAuthStateChanged } from 'firebase/auth';
import './componentsStyle/navbar.css';
import logo from './image/logo.png'; // Adjust file name/extension if needed (e.g., logo.svg)

const Navbar = () => {
  const [user, setUser] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();

  // Listen to Firebase auth state
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
    return () => unsubscribe();
  }, []);

  const handleLogout = async () => {
    await signOut(auth);
    setMobileOpen(false);
    navigate('/');
  };

  const closeMobileMenu = () => setMobileOpen(false);
  const toggleMobileMenu = () => setMobileOpen((prev) => !prev);

  const isAdmin = user?.email === "xluxe333@gmail.com";

  return (
    <>
      {/* Desktop/Mobile Navbar */}
      <header className="g-nav">
        <div className="g-nav-inner">
          <Link to="/" className="g-logo" onClick={closeMobileMenu}>
            <img src={logo} alt="Xluxe Logo" className="g-logo-img" />
          </Link>

          {/* Desktop Links */}
          <nav className="g-links">
            <Link to="/" onClick={closeMobileMenu}>Home</Link>
            <Link to="/products" onClick={closeMobileMenu}>Products</Link>
            <Link to="/trending" onClick={closeMobileMenu}>Trending</Link>
            <Link to="/about" onClick={closeMobileMenu}>About</Link>
            <Link to="/blog" onClick={closeMobileMenu}>Blog</Link>
            {isAdmin && <Link to="/admin-dashboard" onClick={closeMobileMenu}>Admin</Link>}
          </nav>

          {/* Right Section */}
          <div className="g-right">
            {user ? (
              <div className="g-user">
                <img
                  src={user.photoURL || `https://ui-avatars.com/api/?name=${encodeURIComponent(user.email)}&background=1a1a1a&color=fff&bold=true`}
                  alt="Profile"
                  className="g-avatar"
                />
                <span className="g-username">
                  {user.displayName || user.email.split("@")[0]}
                </span>
                <button onClick={handleLogout} className="g-btn g-btn-logout">
                  Logout
                </button>
              </div>
            ) : (
              <Link to="/admin-login" className="g-btn g-btn-outline">
                Admin Login
              </Link>
            )}

            {/* Hamburger - visible only on mobile */}
            <button
              className="g-hamburger"
              onClick={toggleMobileMenu}
              aria-label="Toggle mobile menu"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Menu */}
      {/* Mobile Menu + Overlay - always rendered */}
      <div className={`g-mobile-menu ${mobileOpen ? "open" : ""}`}>
        <div className="g-mobile-header">
          <div className="g-mobile-user">
            {user ? (
              <>
                <img
                  src={user.photoURL || `https://ui-avatars.com/api/?name=${encodeURIComponent(user.email)}&background=1a1a1a&color=fff&bold=true`}
                  alt="Profile"
                />
                <span>Hello, {user.displayName || user.email.split("@")[0]}</span>
              </>
            ) : (
              <span>Hello, Guest</span>
            )}
          </div>
          <button onClick={closeMobileMenu} className="g-close-menu">×</button>
        </div>

        {/* Mobile Navigation Links */}
        <Link to="/" onClick={closeMobileMenu}>Home</Link>
        <Link to="/products" onClick={closeMobileMenu}>Products</Link>
        <Link to="/trending" onClick={closeMobileMenu}>Trending</Link>
        <Link to="/about" onClick={closeMobileMenu}>About</Link>
        <Link to="/blog" onClick={closeMobileMenu}>Blog</Link>
        {isAdmin && <Link to="/admin-dashboard" onClick={closeMobileMenu}>Admin</Link>}

        {user ? (
          <button className="g-mobile-logout" onClick={handleLogout}>Logout</button>
        ) : (
          <Link to="/admin-login" onClick={closeMobileMenu} className="g-mobile-login">Admin Login</Link>
        )}
      </div>

      <div className={`g-overlay ${mobileOpen ? "show" : ""}`} onClick={closeMobileMenu}></div>

      {/* Overlay */}
      <div
        className={`g-overlay ${mobileOpen ? 'show' : ''}`}
        onClick={closeMobileMenu}
      />
    </>
  );
};

export default Navbar;